import React from 'react';
import { string, bool, func } from 'prop-types';
import { CheckNearByStore } from './CheckNearByStore';
import './dominantTooltip.scss';

const BossDominantTooltip = ({
  isShipToHomeEligible,
  itemId,
  onClick
}) => (
  <div className="BossSharedToolTip__wrapper">
    <div className="BossSharedToolTip__content">
      <span className="u__clearfix">
        <div className="u__bold" id="need-more-text-message">Need More? We can ship it to your store!</div>
        <div>Just enter the quantity you need, and we will ship it to
          <span className="u__bold"> Cumberland </span>for free pickup.
        </div>
        <br />
        <span className="u__bold">Need it sooner? </span>
        <CheckNearByStore
          itemId={itemId}
          isShipToHomeEligible={isShipToHomeEligible}
        >
          <span role="button" tabIndex={0} onClick={onClick}>Check Nearby Stores </span>
        </CheckNearByStore>
        <span>
          to see if another store has enough items in stock. You can also split your order across multiple stores.
        </span>
      </span>
    </div>
  </div>
);

BossDominantTooltip.propTypes = {
  itemId: string.isRequired,
  isShipToHomeEligible: bool,
  onClick: func
};
BossDominantTooltip.defaultProps = {
  isShipToHomeEligible: false,
  onClick: () => {}
};

export { BossDominantTooltip };
